import React from 'react';

const LocationResultCard = props => {
  return (
    <div className="location-result-card--wrapper">
      <div
        className="image--wrapper"
        dangerouslySetInnerHTML={{ __html: props.locationImageElement }}
      />
      <div
        className="miles-away--wrapper"
        dangerouslySetInnerHTML={{ __html: props.milesAwayText }}
      />
      <div className="location-details--wrapper">
        <div
          className="location-name--wrapper"
          dangerouslySetInnerHTML={{ __html: props.locationName }}
        />
        <p className="location-address">{props.locationAddress}</p>
        <div
          className="hours--wrapper"
          dangerouslySetInnerHTML={{ __html: props.locationHours }}
        />
        <div
          className="phone--wrapper"
          dangerouslySetInnerHTML={{ __html: props.locationPhone }}
        />
        <button
          className="directions-button styleless-button"
          onClick={() => props.openDirections(props.locationAddress)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v2c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1h5V7.5l3.15 3.15c.2.2.2.51 0 .71L14 14.5z" />
          </svg>
          {props.directionsLabel}
        </button>
        <div
          className="view--wrapper"
          dangerouslySetInnerHTML={{ __html: props.viewLocationLink }}
        />
      </div>
    </div>
  );
};

export default LocationResultCard;
